<template src='./gridDetailsModal.pug' lang='pug'></template>

<script>
import { mapGetters } from 'vuex'
import { VueTabs, VTab } from 'vue-nav-tabs'
import BetterModal from '../betterModal/BetterModal'
import TabDetails from './tabDetails/TabDetails'
import TabIntegrations from './tabIntegrations/TabIntegrations'
import TabHistoric from './tabHistoric/TabHistoric'
import TabAllotment from './tabAllotment/TabAllotment'
import TabTasks from './tabTasks/TabTasks'
import TabClassification from './tabClassification/TabClassification'
import closeModal from '../../../events/closeModal.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import popExitingConfirmation from '../../../utils/popExitingConfirmation'

export default {
  name: 'GridDetailsModal',

  components: {
    VueTabs,
    VTab,
    BetterModal,
    TabDetails,
    TabIntegrations,
    TabHistoric,
    TabAllotment,
    TabTasks,
    TabClassification
  },

  props: {
    id: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    closeFunction: {
    },
    tabs: {
      type: Array,
      required: true
    },
    defaultTab: {
      type: String,
      required: false,
      default: 'gridDetailsModal-tabDetails'
    },
    labelModalTitle: {
      type: String,
      default: 'modalDetalhesLanc.titulos.titulo'
    },
    labelModalSubTitle: {
      type: String,
      default: 'modalDetalhesLanc.titulos.subtitulo'
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tabName: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
      mustReloadParent: false
    }
  },

  computed: {
    modalTitle () {
      return this.$t(this.labelModalTitle)
    },

    modalSubtitle () {
      return this.$t(this.labelModalSubTitle)
    },

    hasUnsavedChanges () {
      return this.$store.getters.hasUnsavedChanges
    },

    ...mapGetters([
      'isManagingTask'
    ])
  },

  watch: {
    tabs () {
      let self = this
      if (self.defaultTab === 'gridDetailsModal-tabDetails') {
        setTimeout(() => {
          self.$refs.tabRouter.navigateToTab(0)
        }, 100)
        self.tabName = self.$t('modalDetalhesLanc.titulos.tabDetalhes')
      } else if (self.defaultTab === 'gridDetailsModal-tabTasks') {
        setTimeout(() => {
          self.$refs.tabRouter.navigateToTab(this.tabs.length - 1)
        }, 100)
      }
    }
  },

  methods: {
    trackEvent () {
      if (this.hasUnsavedChanges && !popExitingConfirmation()) {
        return
      }
      this.$store.dispatch('setHasUnsavedChanges', false)
      trackAnalyticsEvent(this, 'close-grid-modal', 'titlebar-close-click', this.id)
      closeModal.$emit('modalDetailsClose', this.mustReloadParent)
      this.$emit('closeDetailsModal')
      window.Grids[0].Enable()
      if (this.$refs.tabTasksGridModal) {
        this.$refs.tabTasksGridModal[0].$children[0].clearManagementTask()
      }
    },

    handleTabChange (tabIndex, newTab, oldTab) {
      trackAnalyticsEvent(this, 'tab-click', newTab.id + '-click', this.getTabIdLanc(newTab.id))
      this.$store.dispatch('setHasUnsavedChanges', false)
      switch (newTab.id) {
        case 'gridDetailsModal-tabDetails':
          break
        case 'gridDetailsModal-tabIntegrations':
          this.$refs.tadIntegrationGridModal[0].$children[0].loadProcFile()
          break
        case 'gridDetailsModal-tabHistoric':
          this.$refs.tabHisotiricGridModal[0].$children[0].clickAction()
          break
        case 'gridDetailsModal-tabAllotment':
          this.$refs.tadAllotmentGridModal[0].$children[0].loadAllotment()
          break
        case 'gridDetailsModal-tabTasks':
          this.$refs.tabTasksGridModal[0].$children[0].loadTaskData(this.isManagingtask)
          break
        case 'gridDetailsModal-tabTask':
          this.$refs.tabTasksGridModal[0].$children[0].loadTaskDetail()
          break
        case 'gridDetailsModal-tabClassification':
          this.$refs.tabClassificationGridModal[0].$children[0].prepareTab()
          break
        default:
          break
      }
    },

    getTabIdLanc (tabId) {
      let lanc = null
      this.tabs.forEach(tab => {
        if (tab.idTabRoot === tabId) {
          lanc = tab.idLanc
        }
      })
      return lanc
    },

    // Verifica se possui permissão para exibir a aba. Atualmente, só há essa verificação para a aba de tarefas, pois o usuário só pode
    // ter acesso a essa aba caso tenha permissão da funcionalidade 'TAREFAS'.
    // Para as outras abas não há verificação específica, por isso a funcionalidade(id) das outras abas é passada como NULL
    verifyTabAuthorization (id) {
      if (!id) {
        return true
      } else {
        if (this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.length > 0 && this.$store.getters.allowedFuncionalities.indexOf(id) >= 0) {
          return true
        }
      }
      return false
    }
  },

  mounted () {
    closeModal.$on('taskChange', (flag) => {
      this.mustReloadParent = flag
    })
  }
}
</script>

<style lang='css'>
#main-value-container.main-container {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 15px;
}

#statuses-container {
  margin-top: 10px;
}

#tab-historic-id {
  margin: 0 !important;
  padding-top: 10px;
  height: 71vh !important;
  width: 100% !important;
}

#tabbed-modal {
  min-height: 71vh !important;
}

.tab.tab-container {
  height: 100%;
}

#tab-details-id {
  position: relative;
  height: 100%;
}

#footer-monetary-container {
  bottom: 0;
  position: absolute;
  width: 100%;
}

#footer-monetary-detail-container {
  position: inherit;
  width: 100%;
}

#tab-allotment-id {
  position: relative;
  height: 100%;
}

#tab-tasks-id {
  position: relative;
  height: 100%;
}

.modal-lg {
  width: 75vw;
}

.tab-icon-font {
  font-size: 12px;
}

.tab {
  margin-top: 0px !important;
}

.tabbed-modal-body {
  padding: 0px !important;
}

#tabbed-modal.vue-tabs .nav-tabs {
  border-bottom: none;
}

#tabbed-modal.vue-tabs .nav>li.active span.title {
  color: #37F3F5;
  font-size: 12px;
}

#tabbed-modal.vue-tabs .nav>li span.title {
  color: #8AA4AF;
  font-size: 12px;
}

/*Active*/
#tabbed-modal.vue-tabs .nav-tabs>li.active>a,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {
  border-left: 5px solid!important;
  border-color: #37F3F5!important;
  -webkit-transition: all 0.2ms!important;
  -moz-transition: all 0.2ms!important;
  -o-transition: all 0.2ms!important;
  transition: all 0.2s!important;
  border-top: 0px !important;
  border-right: 0px !important;
  border-bottom: 0px !important;
  background: #132E4D;
  color: #37F3F5!important;
}

#tabbed-modal.vue-tabs .nav-tabs>li>a,
#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,
#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {
  border: none !important;
  color: #8AA4AF;
  background: transparent;
  border-radius: 0px;
  margin-right: 0px;
}

#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {
  background: #10253E;
}

.left-vertical-tabs {
  background: #1B3C65;
}

.modal .modal-content {
  border-left: none;
  border-bottom: none;
  border-right: none;
}

.tab-historic {
  max-height: 450px;
  overflow-y: auto;
}

.tab-left {
  text-align: center
}

#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{
  text-align: center;
  margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// GridDetailsModal.vue?05caa0e8